import { APP_JSON } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import StaticIdSingletonClass from '../../helpers/static-id';
import CONFIG from '../../settings';

/**
 * Query /device API with THM profile ID to fetch API hint for subsequent UNL API call(s).
 * @returns {Promise}
 */
export const fetchThmHeaderHint = () => {
  const body = {
    context: {
      channel: 'Web',
      eventSource: 'LightboxTW',
      uebas: [
        {
          // VCO-14303 - as of Holiday 2020, THM profile ID is being returned all lowercase; re-use X-THMID/sessionId value with original casing.
          ueba_id: StaticIdSingletonClass.sessionId || CONFIG.application.defaults.dfpSessionId,
          ueba_source: 'THM'
        }
      ]
    }
  };

  return fetchReq({
    body,
    headers: {
      Accept: APP_JSON,
      'Content-Type': APP_JSON
    },
    method: 'POST',
    url: CONFIG.application.api.device
  }).then(res => {
    if (!res.ok) {
      throw new Error('/device API not available.  THM profile ping failed.');
    }

    // VCO-14593 - /idLookup requires x-via-hint instead of x-via-hint_dca
    const thmProfileHint = res.headers['x-via-hint'];

    // get 'x-via-hint_dca' header and preserve for subsequent fetch calls (UNL is primary use-case)
    return Promise.resolve(thmProfileHint || undefined);
  });
};
